/**
 * useClinics — GET /v1/clinics
 *
 * Lists every MIPS-active clinic in the tenant. Powers the clinic switcher
 * Combobox on the dashboard page and the admin clinic-activation page.
 */
import { useQuery } from "@tanstack/react-query";
import { getApiClient } from "@/api/client";
import type { ClinicListResponse } from "@/api/models";
import { queryKeys } from "./queryKeys";

export function useClinics() {
  return useQuery({
    queryKey: queryKeys.clinics.list(),
    queryFn: async (): Promise<ClinicListResponse> => {
      const { data } = await getApiClient().get<ClinicListResponse>("/v1/clinics");
      return data;
    },
    staleTime: 60_000,
  });
}
